import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles(theme => {
    const t = getTokens(theme.palette.type, theme.palette.primary.main);
    return {
        root: { minWidth: 0 },
        label: {
            display: "block",
            marginBottom: 6,
            fontSize: 12.5,
            fontWeight: 600,
            lineHeight: 1.4,
            color: t.textSecondary,
        },
        chips: { display: "flex", flexWrap: "wrap", gap: 6 },
        // fileira discreta: contorno neutro, a marca só aparece no hover
        chip: {
            cursor: "pointer",
            fontWeight: 500,
            color: t.mode === "dark" ? t.text : t.label,
            backgroundColor: t.paper,
            border: `1px solid ${t.line}`,
            transition: `border-color ${t.motion.fast}, background-color ${t.motion.fast}, color ${t.motion.fast}`,
            "&:hover, &:focus": {
                backgroundColor: `${t.tint.soft} !important`,
                borderColor: t.tint.strong,
                color: t.brand,
            },
        },
        disabled: { opacity: 0.55, "& $chip": { cursor: "default" } },
    };
});

const MessageVariablesPicker = ({ onClick, disabled, showSchedulingVars = false }) => {
    const classes = useStyles();

    const handleClick = (e, value) => {
        e.preventDefault();
        if (disabled) return;
        onClick(value);
    };

    const msgVars = [
        {
            name: i18n.t("messageVariablesPicker.vars.contactFirstName"),
            value: "{{firstName}}"
        },
        {
            name: i18n.t("messageVariablesPicker.vars.contactName"),
            value: "{{name}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.user"),
            value: "{{userName}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.greeting"),
            value: "{{ms}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.protocolNumber"),
            value: "{{protocol}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.date"),
            value: "{{date}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.hour"),
            value: "{{hour}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.ticket_id"),
            value: "{{ticket_id}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.queue"),
            value: "{{queue}} "
        },
        {
            name: i18n.t("messageVariablesPicker.vars.connection"),
            value: "{{connection}} "
        }
    ];

    // Adiciona variáveis específicas para agendamento e resposta rápida
    if (showSchedulingVars) {
        msgVars.push({
            name: i18n.t("messageVariablesPicker.vars.scheduledDate"),
            value: "{{dataAgendamento}} "
        });
    }

    return (
        <div className={`${classes.root} ${disabled ? classes.disabled : ""}`}>
            <span className={classes.label}>{i18n.t("messageVariablesPicker.label")}</span>
            <div className={classes.chips}>
                {msgVars.map(msgVar => (
                    <Chip
                        key={msgVar.value}
                        onMouseDown={e => handleClick(e, msgVar.value)}
                        label={msgVar.name}
                        size="small"
                        variant="outlined"
                        className={classes.chip}
                    />
                ))}
            </div>
        </div>
    );
};

export default MessageVariablesPicker;